module.exports = __webpack_public_path__ + "img/webSessions.f5961760.png";